
import { getEnvVariable } from "../../../modules/environmentalList"

const InvoiceCycleAdd = {
    "type": "popup",
    "key": "InvoiceCycleAdd",
    "name": "InvoiceCycleAdd",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'addOpen'
    },
    sharedValues: ['open'],
    container: {
        values: { save: false, back: false, fullscreen: false, },
        mapValues: {
            header: [
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
            ],
            InvoiceCycle: [{ key: 'save', name: 'save' },
            { key: 'exitfullscreen', name: 'exitfullscreen' },
            { key: 'fullscreen', name: 'fullscreen' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: '',
                style: { marginLeft: '4px', marginRight: '4px' },
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row m-1 application-border',
                components: [{
                    name: 'InvoiceCycle',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Invoice Cycle',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "Invoice Cycle", "materialicon": "attach_money", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        color:'green',
                        name: 'save',
                        hideon: 'save',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit Full Screen'
                    }
                ],


            },
            InvoiceCycle: {
                "type": "form",
                "key": "InvoiceCycle",
                "name": "InvoiceCycle",
                aliases: {
                    save: 'save',
                },
                //"routeParams": { replace: 'invoicecycles', param: 'Id', routeName: 'id' },
                sharedValues: ['save', 'back', 'exitfullscreen', 'fullscreen'],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Name',
                                type: 'div',
                                className: 'col-10 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                }
                            }],

                        },

                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Description',
                                type: 'div',
                                className: 'col-10 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                }
                            }
                            ]
                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'IsInvoiced',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'InvoicePeriod',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },


                            ]
                        },
                        {
                            order: 3,
                            type: 'div',
                            className: 'row',
                            components: [
                            {
                                name: 'InvoiceType',
                                type: 'div',
                                className: 'col-5 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                }
                            },
                            {
                                name: 'InvoiceOn',
                                type: 'div',
                                className: 'col-5 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                }
                            }
                        ]
                        },
                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'GenerateInvoiceOn',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'GenerateInvoiceDate',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                }
                            ]
                        },
                        {
                            order: 5,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'DateOnInvoice',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'DateToPrintOnInvoice',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                }
                            ]
                        },
                        {
                            order: 6,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'PaymentDueOnInvoice',
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10 mt-2',
                                    }
                                }
                            ]
                        },
                        {
                            order: 7,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'PaymentDueDays',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                },
                                {
                                    name: 'PaymentDueDate',
                                    type: 'div',
                                    className: 'col-5 mt-2',
                                    sub: {
                                        type: 'div',
                                        className: 'col-5 mt-2',
                                    }
                                }
                            ]
                        },
                        {
                            order: 8,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Status',
                                type: 'div',
                                className: 'col-10 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 mt-2',
                                }
                            }]
                        },
                        
                    ],
                },
                values: {
                    Name: '',
                    Description: '',
                    IsInvoiced: '',
                    InvoicePeriod: '',
                    InvoiceType: '',
                    InvoiceOn: '',
                    GenerateInvoiceOn: '',
                    DateOnInvoice: '',
                    PaymentDueOnInvoice: '',
                    GenerateInvoiceDate: '',
                    DateToPrintOnInvoice: '',
                    PaymentDueDate: '',
                    PaymentDueDays: '',
                    Status: 'I'
                },

                "components": {
                    Name: {
                        "type": "textfield",
                        "key": "Name",
                        "label": "Name",
                        "name": "Name",
                        // extraProps: {
                        //     transformProps: {
                        //         label: 'Name',
                        //         value: 'Value'
                        //     },
                        // }
                    },
                    Description: {
                        "type": "textfield",
                        "key": "Description",
                        "label": "Description",
                        "name": "Description",
                    },
                    IsInvoiced: {
                        "type": "radiogroup",
                        "key": "IsInvoiced",
                        "label": "Is Invoiced",
                        "name": "IsInvoiced",
                        //custom: true,//Used in sections but not here based on the conditions.
                        //defaultvalue: "Y",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'Y', name: 'Invoice Every' }, { value: 'N', name: 'Invoice On' }]
                    },
                    InvoicePeriod: {
                        "type": "textfield",
                        "key": "InvoicePeriod",
                        "label": "Invoice Period",
                        "name": "InvoicePeriod",
                        "xtype": "number"
                    },
                    InvoiceType: {
                        "type": "dropdown",
                        "key": "InvoiceType",
                        "label": "InvoiceType",
                        "name": "InvoiceType",
                        extraProps: {
                            transformProps: {
                                label: 'Name',
                                value: 'Value'
                            },
                        }
                    },
                    InvoiceOn: {
                        "type": "radiogroup",
                        "key": "InvoiceOn",
                        "label": "Invoice On",
                        name: "InvoiceOn",
                        //custom: true,//Used in sections but not here based on the conditions.
                        //defaultvalue: "E",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'E', name: 'Even Year' }, { value: 'O', name: 'Odd Year' }]
                    },
                    GenerateInvoiceOn: {
                        "type": "radiogroup",
                        "key": "GenerateInvoiceOn",
                        "label": "Generate Invoice On",
                        name: "GenerateInvoiceOn",
                        //defaultvalue: "D",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'D', name: 'Particular Date' }, { value: 'P', name: 'Permitted Date' }]
                    },
                    GenerateInvoiceDate: {
                        "type": "date",
                        "key": "GenerateInvoiceDate",
                        "label": "Generate Invoice Date",
                        name: "GenerateInvoiceDate",
                        // extraProps: {
                        //     dateFormat: 'MM/DD'
                        // }
                    },
                    DateOnInvoice: {
                        "type": "radiogroup",
                        "key": "DateOnInvoice",
                        "label": "Date Printed On Invoice",
                        name: "DateOnInvoice",
                        //defaultvalue: "D",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'D', name: 'Particular Date' }, { value: 'P', name: 'Invoice Generated Date' }]

                    },
                    DateToPrintOnInvoice: {
                        "type": "date",
                        "key": "DateToPrintOnInvoice",
                        "label": "Date To Print On Invoice",
                        name: "DateToPrintOnInvoice",
                        // extraProps: {
                        //     dateFormat: 'MM/DD'
                        // }
                    },
                    PaymentDueOnInvoice: {
                        "type": "radiogroup",
                        "key": "PaymentDueOnInvoice",
                        "label": "Payment Due On Invoice",
                        name: "PaymentDueOnInvoice",
                       // defaultvalue: "P",
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'P', name: 'Day(s) from date printed on invoice' }, { value: 'D', name: 'Particular Date' }]

                    },
                    PaymentDueDays: {
                        "type": "textfield",
                        "key": "PaymentDueDays",
                        "label": "Payment Due Days",
                        "name": "PaymentDueDays",
                        "xtype": "number"
                    },
                    PaymentDueDate: {
                        "type": "date",
                        "key": "PaymentDueDate",
                        "label": "Payment Due Date",
                        name: "PaymentDueDate",
                        // extraProps: {
                        //     dateFormat: 'MM/DD'
                        // }
                    },
                    Status: {
                        "type": "toggle",
                        "key": "Status",
                        "label": "Status",
                        "name": "Status",
                        extraProps: {
                            "transformProps": {
                                "A": true,
                                "I": false,
                                "true": "A",
                                "false": "I"
                            }
                        }
                    },
                },
                mapActionsToEffects: {
                    'onLoad': {
                        init: {
                            rules: [{
                                run:
                                {
                                    valid: [
                                    {
                                        type: 'load',
                                        name: 'InvoiceType',
                                        "read": [
                                            {
                                                url: getEnvVariable('Admin')+`/api/Domains/values?domainkey=INVOICE_TYPE`,
                                                type: 'get',
                                                saveAs: {
                                                    key: 'items'
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        type: 'businessrules',
                                        "read": [
                                            {
                                                url: getEnvVariable('Application') + `/api/BusinessRules/Grid/admin.invoicecycle`,
                                                type: 'get',
                                            }
                                        ],
                                    },

                                    {
                                        type: 'validations', 
                                        "read": [
                                            {
                                                "url": getEnvVariable('Admin') + `/api/ProjectMessages/RulesByName?name=admin.invoicecycle`,
                                                type: 'get'
                                            }
                                        ],
                                        transformProps: {
                                            removesubfieldname: `${getEnvVariable('ModuleKey')}ADMIN.INVOICECYCLE_`
                                        }
                                    },
                                    ]
                                }
                            }]
                        },
                        'exitfullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'exitfullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'fullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'fullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    },
                    'afterSave': {
                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/InvoiceCycle/Add`,
                                                        type: 'post',
                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    }
                }
            }
        },

    }
}

export default InvoiceCycleAdd



